export class BaseRecord<T> {
    id: T | undefined;
    createdOn!: string| null;
    updatedOn!: string| null;
    isDeleted: boolean;


    constructor() {
        this.id = undefined;
        this.createdOn = null;
        this.updatedOn = null;
        this.isDeleted = false;
    }
}
